module.exports = __webpack_public_path__ + "static/cale-84d0cd3bf1f8a14128ad6e73118f1cb6.jpg";